export function sortRecords(records, field, direction, numericFields) {
  return [...records].sort((left, right) => {
    const a = left[field];
    const b = right[field];
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;
    const comparison = numericFields.includes(field) ? Number(a) - Number(b) : String(a).localeCompare(String(b));
    return direction === "asc" ? comparison : -comparison;
  });
}
